import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  submit(event) {
    event.preventDefault();

    const button = document.getElementById("analyzeButton");
    button.disabled = true;
    button.innerHTML = '<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Processing...'; // Change text to include spinner

    const fileInput = document.querySelector("#asset_image");
    if (!fileInput || !fileInput.files.length) {
      alert("Please select an image first.");
      button.disabled = false; // Re-enable if no file
      button.textContent = "Analyze image with AI for title and description";
      return;
    }

    const formData = new FormData();
    formData.append("image", fileInput.files[0]);

    fetch(button.href, {
      method: "POST",
      body: formData,
      headers: { "X-CSRF-Token": document.querySelector("[name='csrf-token']").content }
    })
    .then(response => response.json())
    .then(data => {
      console.log("Image analyzed:", data);
    })
    .catch(error => {
      console.error("Error:", error);
    })
    .finally(() => {

    });
  }
}
